var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",style:(_vm.newStyle)},[_c('div',{staticClass:"small-loader"}),_c('b',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }